// Mock content for Comfort Air (modern rebuild). This maps directly to the CMS backend later.

export const siteSettings = {
  companyName: 'Comfort Air',
  companyFull: 'Comfort Air Mechanical',
  tagline: 'Heating, Air Conditioning, Sheet Metal & Refrigeration',
  since: 1988,
  phone: '(970) 565-7893',
  phoneRaw: '19705657893',
  fax: '(970) 565-2586',
  email: 'info@comfortair.co',
  address: '2421 E. Empire St.',
  city: 'Cortez, CO 81321',
  hours: [
    { day: 'Monday - Friday', time: '8:00am - 5:00pm' },
    { day: 'Saturday', time: 'By Appointment' },
    { day: 'Sunday', time: 'Closed' }
  ],
  emergencyNote: '24/7 emergency services available!',
  serviceAreas: ['Cortez', 'Mancos', 'Dolores', 'Durango', 'Towaoc', 'Four Corners Area']
};

export const logo = '/CAM_LOGO_GREEN.webp';

export const navItems = [
  { label: 'Home', path: '/' },
  {
    label: 'Services', path: '/residential',
    children: [
      { label: 'Residential', path: '/residential' },
      { label: 'Commercial', path: '/commercial' },
      { label: 'Shop Fabrication', path: '/fabrication' },
      { label: 'Duct Sealing', path: '/duct-sealing' }
    ]
  },
  {
    label: 'Service Areas', path: '/service-areas/cortez-co',
    children: [
      { label: 'Cortez, CO', path: '/service-areas/cortez-co' },
      { label: 'Dolores, CO', path: '/service-areas/dolores-co' },
      { label: 'Yellow Jacket, CO', path: '/service-areas/yellow-jacket-co' },
      { label: 'Telluride, CO', path: '/service-areas/telluride-co' }
    ]
  },
  { label: 'Photos', path: '/gallery' },
  { label: 'Team', path: '/team' },
  { label: 'Contact', path: '/contact' },
  { label: 'Careers', path: '/careers' }
];

export const serviceAreas = [
  {
    slug: 'cortez-co',
    city: 'Cortez',
    state: 'CO',
    title: 'HVAC Services in Cortez, CO',
    subtitle: 'Your local heating & air conditioning experts, headquartered right here in Cortez.',
    intro: 'Comfort Air Mechanical has proudly called Cortez, Colorado home since 1988. As your neighbors, we know exactly what Montezuma County weather demands from your heating and cooling systems.',
    body: [
      'From the hot high-desert summers to freezing winter nights, Cortez homes and businesses rely on dependable HVAC systems. Our fully licensed and insured technicians provide fast, professional air conditioning and furnace installation, repair and maintenance throughout Cortez and the surrounding area.',
      'Because our shop is located in Cortez, we offer some of the quickest response times in the region \u2014 including 24/7 emergency service. Whether you need a new high-efficiency furnace, a ductless mini-split, or routine maintenance, we are just minutes away.'
    ],
    services: ['AC Repair & Installation', 'Furnace Repair & Installation', 'Heat Pumps & Mini-Splits', 'Commercial HVAC', 'Sheet Metal Fabrication', '24/7 Emergency Service'],
    landmarks: 'Proudly serving neighborhoods throughout Cortez, including downtown, the Montezuma County area, and nearby Towaoc.'
  },
  {
    slug: 'dolores-co',
    city: 'Dolores',
    state: 'CO',
    title: 'HVAC Services in Dolores, CO',
    subtitle: 'Reliable heating & cooling for Dolores homes and cabins.',
    intro: 'Comfort Air Mechanical provides expert HVAC services to the Dolores, Colorado community, just a short drive from our Cortez shop.',
    body: [
      'Dolores properties \u2014 from riverside homes to mountain cabins near McPhee Reservoir \u2014 need heating systems that can handle cold Colorado winters. We install and service gas furnaces, heat pumps, wall heaters and gas fireplaces to keep your Dolores property warm and comfortable all year.',
      'Our technicians service all makes and models, and we offer free estimates on new installations. When your system needs attention, our team responds quickly with honest, upfront pricing.'
    ],
    services: ['Furnace & Heating Repair', 'AC Installation & Repair', 'Gas Fireplaces & Wall Heaters', 'Mini-Split Heat Pumps', 'Preventative Maintenance', 'Emergency Service'],
    landmarks: 'Serving Dolores, the McPhee Reservoir area, and surrounding rural properties.'
  },
  {
    slug: 'yellow-jacket-co',
    city: 'Yellow Jacket',
    state: 'CO',
    title: 'HVAC Services in Yellow Jacket, CO',
    subtitle: 'Dependable comfort for rural Yellow Jacket properties.',
    intro: 'Comfort Air Mechanical brings professional heating and cooling services to the Yellow Jacket, Colorado community and surrounding farms and ranches.',
    body: [
      'Rural properties in Yellow Jacket often rely on furnaces, unit heaters and evaporative coolers. Our team specializes in installing and maintaining reliable systems built for agricultural buildings, shops and homes alike \u2014 including Reznor gas-fired unit heaters for workshops and outbuildings.',
      'No job is too far. We regularly serve the Yellow Jacket area with the same quality installation, maintenance and repair service our Cortez neighbors count on.'
    ],
    services: ['Home & Shop Heating', 'Gas-Fired Unit Heaters', 'AC & Evaporative Cooling', 'Ductwork & Fabrication', 'System Maintenance', 'Emergency Repairs'],
    landmarks: 'Serving Yellow Jacket and the surrounding agricultural communities of Montezuma County.'
  },
  {
    slug: 'telluride-co',
    city: 'Telluride',
    state: 'CO',
    title: 'HVAC Services in Telluride, CO',
    subtitle: 'High-country heating & air conditioning you can trust.',
    intro: 'Comfort Air Mechanical extends its trusted HVAC expertise to Telluride, Colorado, delivering premium comfort solutions for mountain homes and businesses.',
    body: [
      'Telluride\u2019s high-altitude climate and luxury properties demand precise, high-performance heating systems. We design and install custom HVAC solutions, high-efficiency furnaces, radiant-ready systems and premium gas fireplaces that stand up to harsh mountain winters.',
      'From ski condos to commercial spaces, our experienced technicians provide meticulous installation and responsive service so you stay comfortable no matter the elevation or the season.'
    ],
    services: ['Custom HVAC Design', 'High-Efficiency Furnaces', 'Premium Gas Fireplaces', 'Commercial Systems', 'Sheet Metal Fabrication', 'Seasonal Maintenance'],
    landmarks: 'Serving Telluride, Mountain Village, and surrounding San Miguel County communities.'
  }
];

export const IMAGES = {
  heroFamily: 'https://images.pexels.com/photos/8054853/pexels-photo-8054853.jpeg',
  technician: 'https://images.pexels.com/photos/6471911/pexels-photo-6471911.jpeg',
  mountains: 'https://images.unsplash.com/photo-1610997186335-12de8a2dc7fd',
  mountains2: 'https://images.unsplash.com/photo-1524429656589-6633a470097c',
  acUnit: 'https://images.unsplash.com/photo-1700124113583-81aa99ea2aa2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  commercial: 'https://images.unsplash.com/photo-1615309662243-70f6df917b59?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  furnace: 'https://images.unsplash.com/photo-1633596879450-e98a1a4d0c80?q=85&w=1200',
  ductwork: 'https://images.unsplash.com/photo-1707596830261-9c6138a6dd3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200'
};

export const homeContent = {
  heroSlides: [
    { kicker: 'Bringing Comfort to', title: 'Your Home 24/7', image: IMAGES.heroFamily },
    { kicker: 'High-Quality Heating', title: 'Installation & Repair', image: IMAGES.technician }
  ],
  heroBullets: [
    'Serving South West Colorado since 1988',
    'Fully Licensed & Insured Technicians',
    '24/7 Emergency Service Available'
  ],
  whyChoose: {
    heading: 'Why Customers Choose Comfort Air',
    paragraph:
      'Comfort Air Mechanical is an air conditioning & heating contractor serving the South West Colorado area with the highest level of HVAC services. We have been serving the Cortez area since 1988. From professional installations to expert repair services, you can trust our fully licensed and insured technicians.',
    features: [
      { icon: 'Clock', title: '24/7 Emergency Service', text: 'When your heater or AC breaks down during peak months, we are here around the clock to get you comfortable again.' },
      { icon: 'Wrench', title: 'We Service All Makes & Models', text: 'Our certified, professionally trained technicians proudly service every HVAC make and model.' },
      { icon: 'ShieldCheck', title: 'Licensed, Insured & Trusted', text: 'A fully licensed and insured team with 35+ years of experience across Southwest Colorado.' }
    ]
  },
  services: [
    { icon: 'Snowflake', title: 'Air Conditioning', text: 'Installation, repair & maintenance to keep you cool all summer long.', path: '/residential' },
    { icon: 'Flame', title: 'Heating & Furnaces', text: 'High-efficiency furnaces, heat pumps & wall heaters expertly installed.', path: '/residential' },
    { icon: 'Building2', title: 'Commercial HVAC', text: 'Custom designed systems for hotels, schools, retail & offices.', path: '/commercial' },
    { icon: 'Wind', title: 'Sheet Metal Fabrication', text: 'Fully equipped in-house fabrication shop for custom ductwork.', path: '/fabrication' }
  ],
  stats: [
    { value: '35+', label: 'Years of Experience' },
    { value: '24/7', label: 'Emergency Service' },
    { value: '100%', label: 'Licensed & Insured' },
    { value: '5', label: 'Trusted Brands' }
  ],
  testimonials: [
    { name: 'Bob & Judy', location: 'Cortez, CO', text: 'The folks at Comfort Air made the installation of our garage heater a real pleasure. Fair price, prompt, clean and courteous installation, and everything worked perfectly the first time.' },
    { name: 'Sandra M.', location: 'Mancos, CO', text: 'Our furnace went out on the coldest night of the year and they had a technician out within the hour. Professional, honest and quick. Highly recommend!' },
    { name: 'The Reynolds Family', location: 'Dolores, CO', text: 'We had a full mini-split system installed. The team was knowledgeable and tidy, and our home has never been more comfortable. Great local company.' }
  ]
};

export const faqs = [
  { q: 'What is the life expectancy of my HVAC system?', a: 'How often you run your system, its age, make and model, and whether it was serviced regularly all play a significant role in how long your system lasts. Regular maintenance is key to any HVAC system!' },
  { q: 'What types of equipment do you install?', a: 'We install Gas Fired Furnaces (Trane), Air Conditioning (Trane), high efficiency mini split heat pumps (Fujitsu Ductless Splits), Gas Fired Unit Heaters (Reznor), Wall Heaters (Empire) and Gas Fireplaces (Napoleon, Superior & Regency).' },
  { q: 'What is a heat pump?', a: 'A heat pump uses outside air to both heat a home in winter and cool it in summer. It acts as an air conditioner when it is hot and a heater when it is cold, making it one versatile, energy-efficient product that transports warm air where it is needed.' },
  { q: 'Do I need HVAC maintenance?', a: 'Routine maintenance is highly recommended. It serves as preventative care to help avoid breakdowns when you need your system the most.' }
];

export const pageContent = {
  residential: {
    title: 'Residential HVAC Services',
    subtitle: 'Keeping your home comfortable in every season',
    image: IMAGES.acUnit,
    intro: 'To enhance the comfort of your home, Comfort Air provides quality air conditioning & heating installation and repair services.',
    body: [
      'When it comes to your residential HVAC needs, you want to feel confident you are working with professionals. Breakdowns and failures with your HVAC system can add excess stress to your life, so trust our experts to provide the necessary repair services. We will work with you to keep your home comfortable.',
      'We promise you the best of our abilities and ensure that your heating & cooling systems run to their full potential. Our trained staff, affordable pricing, and quality service will fulfill all of your heating system needs. Once you call us for installations or repairs, you can count on us for all future assistance.'
    ],
    services: ['AC Installation & Repair', 'Furnace Installation & Repair', 'Mini Split Heat Pumps', 'Wall & Unit Heaters', 'Gas Fireplaces', 'Preventative Maintenance'],
    note: 'Ask us about Local and Federal Rebates & Incentives available for high-efficiency systems.'
  },
  commercial: {
    title: 'Commercial HVAC Services',
    subtitle: 'Custom designed systems for Colorado businesses',
    image: IMAGES.commercial,
    intro: 'For over 35 years, Comfort Air has provided the Cortez and Four Corners area with professional commercial heating and cooling services.',
    body: [
      'We are proud to have worked with some of Colorado\u2019s finest general contractors. We specialize in custom designed HVAC systems, and our commercial experience includes area hotels, restaurants, schools, retail spaces and office buildings.',
      'We have developed a system of high-quality installation, maintenance and service repair techniques for all your air conditioning and heating system needs. Our purpose is to enhance your indoor air comfort while conserving energy and maximizing your equipment\u2019s performance.',
      'We offer 24 hour emergency service, and we will get your heating or cooling system back up and running in hours, not days.'
    ],
    services: ['Custom System Design', 'Rooftop Units (RTU)', 'Refrigeration', 'Preventative Maintenance Plans', 'Retrofits & Upgrades', '24-Hour Emergency Service'],
    note: 'Whatever your commercial heating and cooling needs may be, we can provide it at prices you can afford.'
  },
  fabrication: {
    title: 'Shop Fabrication',
    subtitle: 'Custom sheet metal, built in-house',
    image: IMAGES.ductwork,
    intro: 'Our fully equipped fabrication shop lets us build custom sheet metal ductwork and fittings to fit any project.',
    body: [
      'From complex commercial ductwork to one-off residential fittings, our in-house sheet metal shop gives us complete control over quality and turnaround. This means better-fitting, more efficient systems for your home or business.',
      'Because we fabricate on-site, we can react quickly to job-site changes and custom requirements without waiting on outside suppliers.'
    ],
    services: ['Custom Ductwork', 'Sheet Metal Fittings', 'Transitions & Plenums', 'Range Hoods', 'Flashing & Trim', 'Custom Metal Projects'],
    note: 'Have a custom metal project? Contact us for a free quote.'
  },
  ductSealing: {
    title: 'Duct Sealing & Energy Efficiency',
    subtitle: 'Stop paying to heat and cool your attic',
    image: IMAGES.furnace,
    intro: 'Leaky ductwork can waste up to 30% of the air moving through your system. Professional duct sealing improves comfort and lowers your energy bills.',
    body: [
      'Our technicians locate and seal leaks throughout your duct system, improving airflow to every room and reducing strain on your equipment. The result is a more comfortable, more efficient home.',
      'Ask us about local and federal rebates and incentives that may help offset the cost of energy-efficiency upgrades.'
    ],
    services: ['Duct Leak Testing', 'Professional Duct Sealing', 'Airflow Balancing', 'Insulation Upgrades', 'Energy Efficiency Audits', 'Rebate Assistance'],
    note: 'A properly sealed system pays for itself in comfort and lower utility bills.'
  }
};

export const galleryImages = [
  { src: 'https://images.unsplash.com/photo-1615309662243-70f6df917b59?crop=entropy&cs=srgb&fm=jpg&q=85&w=900', caption: 'Commercial Rooftop Ductwork' },
  { src: 'https://images.unsplash.com/photo-1757219525975-03b5984bc6e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900', caption: 'System Installation' },
  { src: 'https://images.pexels.com/photos/3964692/pexels-photo-3964692.jpeg?auto=compress&cs=tinysrgb&w=900', caption: 'Technician Service Call' },
  { src: 'https://images.unsplash.com/photo-1700124113583-81aa99ea2aa2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900', caption: 'Residential AC Condenser' },
  { src: 'https://images.unsplash.com/photo-1710829558360-6f8f5e49fedd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900', caption: 'Mini Split Heat Pump' },
  { src: 'https://images.unsplash.com/photo-1707596830261-9c6138a6dd3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900', caption: 'Custom Sheet Metal Ductwork' },
  { src: 'https://images.unsplash.com/photo-1633596879450-e98a1a4d0c80?q=85&w=900', caption: 'High-Efficiency Furnace' },
  { src: 'https://images.pexels.com/photos/6471911/pexels-photo-6471911.jpeg?auto=compress&cs=tinysrgb&w=900', caption: 'Outdoor Unit Maintenance' }
];

export const teamMembers = [
  { name: 'Mike Sanders', role: 'Owner / Master Technician', bio: 'Founder of Comfort Air with 35+ years keeping Southwest Colorado comfortable.', initials: 'MS' },
  { name: 'Dave Whitman', role: 'Service Manager', bio: 'Leads our residential and commercial service teams across the Four Corners.', initials: 'DW' },
  { name: 'Carlos Reyes', role: 'Lead Install Technician', bio: 'NATE-certified specialist in furnaces, heat pumps and mini-split systems.', initials: 'CR' },
  { name: 'Jenny Blake', role: 'Sheet Metal Fabricator', bio: 'Runs our in-house fabrication shop building custom ductwork and fittings.', initials: 'JB' },
  { name: 'Tom Alvarez', role: 'Commercial Estimator', bio: 'Designs custom commercial HVAC systems for contractors and businesses.', initials: 'TA' },
  { name: 'Sara Cline', role: 'Office Manager', bio: 'Your first friendly point of contact for scheduling and questions.', initials: 'SC' }
];

export const manufacturers = [
  { name: 'Trane', text: 'Gas fired furnaces & air conditioning. \u201cIt\u2019s hard to stop a Trane.\u201d' },
  { name: 'Fujitsu General', text: 'High-efficiency ductless mini split heat pumps.' },
  { name: 'Daikin', text: 'Global leader in heating, cooling & air quality.' },
  { name: 'Empire Comfort Systems', text: 'Wall heaters and space heating solutions.' },
  { name: 'Breezair', text: 'Energy-efficient evaporative cooling systems.' },
  { name: 'Reznor', text: 'Gas fired unit heaters for shops and warehouses.' },
  { name: 'Napoleon', text: 'Premium gas fireplaces and hearth products.' },
  { name: 'Regency', text: 'Quality gas fireplaces and inserts.' }
];

export const jobOpenings = [
  { title: 'HVAC Service Technician', type: 'Full-Time', location: 'Cortez, CO', desc: 'Experienced technician to diagnose and repair residential & commercial HVAC systems. EPA certification required.' },
  { title: 'HVAC Installer', type: 'Full-Time', location: 'Cortez, CO', desc: 'Install furnaces, AC units, heat pumps and ductwork. Mechanical aptitude and a clean driving record required.' },
  { title: 'Sheet Metal Apprentice', type: 'Full-Time', location: 'Cortez, CO', desc: 'Entry-level position in our fabrication shop. Learn the trade from experienced fabricators. No experience necessary.' }
];

export const serviceOptions = ['Air Conditioning', 'Heating / Furnace', 'Commercial HVAC', 'Sheet Metal / Fabrication', 'Duct Sealing', 'Maintenance', 'Other'];

export const careersHtml = `<h2>Join the Comfort Air Team</h2>
<p>Comfort Air Mechanical has been keeping Southwest Colorado comfortable since 1988. We are a hard-working local team that takes pride in quality work and taking care of our customers and each other.</p>
<p>We are always looking for reliable, motivated people who want to build a career in the HVAC trade &mdash; experienced technicians and installers as well as apprentices willing to learn.</p>
<h3>How to Apply</h3>
<p>Email your resume to <a href="mailto:info@comfortair.co">info@comfortair.co</a> or call us at <a href="tel:19705657893">(970) 565-7893</a>. You can also stop by our shop at 2421 E. Empire St., Cortez, CO 81321.</p>
<p><em>Comfort Air Mechanical is an equal opportunity employer.</em></p>`;


export const rebateBanner = {
  enabled: true,
  heading: 'Energy Rebates Available',
  text: 'Save on your new high-efficiency system \u2014 please ask us about energy rebates from Atmos Energy and Empire Electric!'
};
